import gql from 'graphql-tag';

export default gql`
  fragment ClientCommon on Client {
    id
    title
    subdomain
    email_domains
    content_domains
    client_status
    authentication_type
    allow_user_signup
    departments_in_signup
    departments_in_signup_required
    locations_in_signup
    locations_in_signup_required
    default_timezone
    default_language
    support_multiple_languages
    social_media_policy_enabled
    social_media_policy_title
    social_media_policy
    public_post_page
    public_post_details
    sso_configuration {
      provider
      domain
      identity_pool_id
      user_pool_id
      region
      app_client_id
    }
    image {
      bucket
      key
      width
      height
      region
    }
  }
`;
